"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = void 0;
var outline_1 = require("@heroicons/react/24/outline");
var react_1 = __importStar(require("react"));
require("../../../index.css");
var iconButton_1 = require("../../action/iconButton");
var link_1 = require("../../structure/link");
var emptyState_1 = require("../emptyState");
var loading_1 = require("../loading");
var defaultLimit = 5;
var defaultPageSize = 5;
var Grid = /** @class */ (function (_super) {
    __extends(Grid, _super);
    function Grid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mouseHandleRef = react_1.default.createRef();
        _this.pos = { top: 0, left: 0, x: 0, y: 0 };
        _this.state = {
            dragging: false,
        };
        _this.handleMouseDown = function (e) {
            if (_this.mouseHandleRef.current && _this.props.horizontalScroll) {
                _this.mouseHandleRef.current.style.cursor = "grabbing";
                _this.mouseHandleRef.current.style.userSelect = "none";
                _this.pos = {
                    left: _this.mouseHandleRef.current.scrollLeft,
                    top: _this.mouseHandleRef.current.scrollTop,
                    x: e.clientX,
                    y: e.clientY,
                };
                _this.mouseHandleRef.current.addEventListener("mousemove", _this.handleMouseMove);
                _this.mouseHandleRef.current.addEventListener("mouseup", _this.handleMouseUp);
            }
        };
        _this.handleMouseMove = function (e) {
            if (_this.mouseHandleRef.current) {
                var dx = e.clientX - _this.pos.x;
                var dy = e.clientY - _this.pos.y;
                _this.mouseHandleRef.current.scrollTop = _this.pos.top - dy;
                _this.mouseHandleRef.current.scrollLeft = _this.pos.left - dx;
                setTimeout(function () {
                    _this.setState({
                        dragging: true,
                    });
                }, 150);
            }
        };
        _this.handleMouseUp = function () {
            if (_this.mouseHandleRef.current && _this.props.horizontalScroll) {
                _this.mouseHandleRef.current.style.cursor = "grab";
                _this.mouseHandleRef.current.style.removeProperty("user-select");
                _this.mouseHandleRef.current.removeEventListener("mousemove", _this.handleMouseMove);
                _this.mouseHandleRef.current.removeEventListener("mouseup", _this.handleMouseUp);
                setTimeout(function () {
                    _this.setState({
                        dragging: false,
                    });
                }, 150);
            }
        };
        _this.handleSelectedGrid = function (id, event) {
            if (_this.props.onClickData && !_this.state.dragging) {
                _this.props.onClickData(id);
            }
            event.preventDefault();
            event.stopPropagation();
        };
        _this.renderPageNumber = function () {
            var _a, _b, _c, _d;
            var pageNumberList = [];
            var pageOffset = Math.floor(((_a = _this.props.pageIndex) !== null && _a !== void 0 ? _a : 0) / defaultPageSize);
            for (var i = pageOffset * defaultPageSize; i * ((_b = _this.props.limit) !== null && _b !== void 0 ? _b : defaultLimit) < ((_c = _this.props.size) !== null && _c !== void 0 ? _c : 0) &&
                i < pageOffset * defaultPageSize + defaultPageSize; i++) {
                var pageNumberClassName = "relative items-center px-3 py-2 border text-sm font-medium cursor-pointer sm:px-4";
                if (_this.props.pageIndex === i) {
                    pageNumberClassName +=
                        " z-10 bg-primary-50 border-primary-500 text-primary-600";
                }
                else {
                    pageNumberClassName +=
                        " border-gray-300 bg-white text-gray-500 hover:text-gray-500 hover:bg-gray-100 bg-white";
                }
                pageNumberList.push(react_1.default.createElement("span", { "aria-current": "page", className: pageNumberClassName, onClick: _this.props.pageIndex !== i
                        ? (_d = _this.props.handleUpdatePageIndex) === null || _d === void 0 ? void 0 : _d.bind(_this, i)
                        : function () { } }, i + 1));
            }
            return pageNumberList;
        };
        _this.renderPagination = function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            var paginationClassName = "relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500";
            var nextDataAvailable = ((_a = _this.props.size) !== null && _a !== void 0 ? _a : 0) >
                (((_b = _this.props.pageIndex) !== null && _b !== void 0 ? _b : 0) + 1) *
                    ((_c = _this.props.limit) !== null && _c !== void 0 ? _c : defaultLimit) || _this.props.cursor;
            switch (_this.props.paginationType) {
                case "cursor":
                    return (react_1.default.createElement("nav", { className: "relative z-0 inline-flex rounded-md shadow-sm -space-x-px", "aria-label": "Pagination" },
                        react_1.default.createElement(iconButton_1.IconButton, { disabled: _this.props.pageIndex === 0 ? true : false, icon: react_1.default.createElement(outline_1.ChevronLeftIcon, { className: "h-5 w-5", "aria-hidden": "true" }), className: "".concat(_this.props.pageIndex === 0
                                ? "cursor-not-allowed"
                                : "bg-primary-50", " ").concat(paginationClassName, " rounded-l-md"), onClick: (_d = _this.props.handleUpdatePageIndex) === null || _d === void 0 ? void 0 : _d.bind(_this, "prev") }),
                        react_1.default.createElement("span", { "aria-current": "page", className: "z-10 bg-white relative inline-flex items-center px-4 py-2 border text-sm font-medium" }, ((_e = _this.props.pageIndex) !== null && _e !== void 0 ? _e : 0) + 1),
                        react_1.default.createElement(iconButton_1.IconButton, { disabled: nextDataAvailable ? false : true, icon: react_1.default.createElement(outline_1.ChevronRightIcon, { className: "h-5 w-5", "aria-hidden": "true" }), className: "".concat(nextDataAvailable ? "bg-primary-50" : "cursor-not-allowed", " ").concat(paginationClassName, " rounded-r-md"), onClick: (_f = _this.props.handleUpdatePageIndex) === null || _f === void 0 ? void 0 : _f.bind(_this, "next") })));
                case "page":
                    return (react_1.default.createElement("nav", { className: "relative inline-flex rounded-md shadow-sm -space-x-px", "aria-label": "Pagination" },
                        react_1.default.createElement(iconButton_1.IconButton, { disabled: _this.props.pageIndex === 0 ? true : false, icon: react_1.default.createElement(outline_1.ChevronLeftIcon, { className: "h-5 w-5", "aria-hidden": "true" }), className: "".concat(_this.props.pageIndex === 0
                                ? "cursor-not-allowed"
                                : "bg-primary-50", " ").concat(paginationClassName, " rounded-l-md"), onClick: (_g = _this.props.handleUpdatePageIndex) === null || _g === void 0 ? void 0 : _g.bind(_this, ((_h = _this.props.pageIndex) !== null && _h !== void 0 ? _h : 0) - 1) }),
                        _this.renderPageNumber(),
                        react_1.default.createElement(iconButton_1.IconButton, { disabled: nextDataAvailable ? false : true, icon: react_1.default.createElement(outline_1.ChevronRightIcon, { className: "h-5 w-5", "aria-hidden": "true" }), className: "".concat(nextDataAvailable ? "bg-primary-50" : "cursor-not-allowed", " ").concat(paginationClassName, " rounded-r-md"), onClick: (_j = _this.props.handleUpdatePageIndex) === null || _j === void 0 ? void 0 : _j.bind(_this, ((_k = _this.props.pageIndex) !== null && _k !== void 0 ? _k : 0) + 1) })));
                default:
                    return react_1.default.createElement("div", null);
            }
        };
        _this.renderPaginatedData = function () {
            var _a, _b;
            var renderBody = [];
            if (_this.props.loading) {
                renderBody.push(react_1.default.createElement("div", { className: "flex-col text-center" },
                    react_1.default.createElement(loading_1.Loading, null),
                    react_1.default.createElement("p", { className: "text-sm text-gray-700 mt-5" }, "Loading...")));
            }
            else if (_this.props.data.length === 0) {
                renderBody.push(react_1.default.createElement(emptyState_1.EmptyState, { text: "There is no data available at the moment", icon: react_1.default.createElement(outline_1.InformationCircleIcon, { className: "h-10 text-gray-600" }) }));
            }
            else {
                if (_this.props.paginationType === "cursor") {
                    var minIndex_1 = ((_a = _this.props.pageIndex) !== null && _a !== void 0 ? _a : 0) * ((_b = _this.props.limit) !== null && _b !== void 0 ? _b : defaultLimit);
                    _this.props.data.map(function (eachData, index) {
                        var _a;
                        if (index >= minIndex_1 &&
                            index < minIndex_1 + ((_a = _this.props.limit) !== null && _a !== void 0 ? _a : defaultLimit)) {
                            renderBody.push(_this.renderRowData(eachData, index));
                        }
                        return null;
                    });
                }
                else {
                    _this.props.data.map(function (eachData, index) {
                        renderBody.push(_this.renderRowData(eachData, index));
                        return null;
                    });
                }
            }
            return renderBody;
        };
        _this.renderTagsAttributes = function (eachData) {
            var attributesList = [];
            if (eachData && eachData.tags) {
                eachData.tags.map(function (eachTags) {
                    attributesList.push(react_1.default.createElement("div", { key: eachTags, className: "bg-primary-600 text-white rounded m-0.5" },
                        react_1.default.createElement("p", { className: "text-xs px-1" }, eachTags)));
                    return null;
                });
            }
            return attributesList;
        };
        _this.renderRowData = function (eachData, index) {
            var _a;
            var renderRowData = [];
            var defaultClassName = "".concat(_this.props.imgContain ? "object-contain" : "object-cover", " h-60 w-full rounded-t");
            var gridClassName = "flex flex-col ".concat(_this.props.newTabUrl || _this.props.onClickData ? "cursor-pointer" : "", " bg-white shadow-md rounded");
            if (_this.props.itemClassName) {
                gridClassName += " ".concat(_this.props.itemClassName);
            }
            if (_this.props.selectedItemClassName &&
                _this.props.selectedItemsId &&
                _this.props.selectedItemsId.includes(eachData.id)) {
                gridClassName += " ".concat(_this.props.selectedItemClassName);
            }
            var gridComp = (react_1.default.createElement(react_1.default.Fragment, null,
                eachData.imageUrl && (react_1.default.createElement("div", null,
                    react_1.default.createElement("img", { className: defaultClassName, src: eachData.imageUrl, alt: "", draggable: false }))),
                react_1.default.createElement("div", { className: "flex flex-col flex-grow space-y-2 p-4 ".concat(_this.props.horizontalScroll ? "w-72" : "") },
                    react_1.default.createElement("div", { className: "text-lg font-medium space-y-1" },
                        eachData.tags && (react_1.default.createElement("div", { className: "flex flex-wrap flex-row" }, _this.renderTagsAttributes(eachData))),
                        react_1.default.createElement("h3", { className: "text-primary-600 font-bold" }, eachData.title),
                        react_1.default.createElement("p", { className: "text-sm text-gray-700 whitespace-pre-line break-words" }, eachData.description.substring(0, 350))),
                    eachData.extra && eachData.extra)));
            renderRowData.push(react_1.default.createElement("li", { key: index, className: gridClassName, onClick: _this.handleSelectedGrid.bind(_this, eachData.id) }, _this.props.newTabUrl ? (react_1.default.createElement(link_1.Link, { href: _this.props.newTabUrl +
                    eachData.id +
                    ((_a = _this.props.addNewTabUrl) !== null && _a !== void 0 ? _a : ""), className: "w-full block", linkType: _this.props.linkType, custom: _this.props.custom }, gridComp)) : (gridComp)));
            return renderRowData;
        };
        _this.renderPageResult = function () {
            if (_this.props.paginationType === "page") {
                return "Showing ".concat(_this.props.size, " result(s)");
            }
            else {
                return "Showing ".concat(_this.props.data.length, " result(s)");
            }
        };
        return _this;
    }
    Grid.prototype.componentDidMount = function () {
        if (this.mouseHandleRef.current) {
            this.mouseHandleRef.current.addEventListener("mousedown", this.handleMouseDown);
        }
    };
    Grid.prototype.componentWillUnmount = function () {
        if (this.mouseHandleRef.current) {
            this.mouseHandleRef.current.removeEventListener("mousedown", this.handleMouseDown);
        }
    };
    Grid.prototype.render = function () {
        var _a;
        var loadingClassNames = "my-10";
        var gridColClassName = "my-10 gap-y-6 ".concat(this.props.horizontalScroll
            ? "flex flex-row w-full pb-2 overflow-x-auto chat-scrollbar "
            : "grid ");
        if (this.props.gridColClassName)
            gridColClassName += "".concat(this.props.gridColClassName);
        else
            gridColClassName += "sm:grid-cols-2 gap-x-6 lg:grid-cols-3 lg:gap-x-8";
        return (react_1.default.createElement("div", { className: (_a = this.props.className) !== null && _a !== void 0 ? _a : "" },
            react_1.default.createElement("div", { ref: this.mouseHandleRef, className: this.props.loading || this.props.data.length === 0
                    ? loadingClassNames
                    : gridColClassName }, this.renderPaginatedData()),
            !this.props.hidePagination && (react_1.default.createElement("div", { className: "w-full flex flex-row items-center justify-end" },
                react_1.default.createElement("span", { className: "text-sm mr-4" }, this.renderPageResult()),
                this.props.paginationType && this.renderPagination()))));
    };
    return Grid;
}(react_1.Component));
exports.Grid = Grid;
//# sourceMappingURL=index.js.map